<script>
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import AppInputDouble from '@/components(new)/UI/Forms/InputDouble/InputDouble'
import onlyInputNumbers from '@/components/mixins/OnlyInputNumber'
import InputSelect from '@/components(new)/UI/Forms/InputSelect/InputSelect.vue'
import TitleWithRow from '@/components(new)/UI/Typography/TitleWithRow/TitleWithRow.vue'
import * as options from '@/libs/constants/praticas/opcoesSelects'
import Bioinsumos from '@/components(new)/UI/Forms/FormulariosProntos/Bioinsumos/Bioinsumos.vue'
import Irrigacao from '@/components(new)/UI/Forms/FormulariosProntos/Irrigacao/Irrigacao.vue'
import Financiamentos from '@/components(new)/UI/Forms/FormulariosProntos/Financiamentos/Financiamentos.vue'
import EspecieEspacamento from '@/components(new)/UI/Forms/FormulariosProntos/EspecieEspacamento/EspecieEspacamento.vue'

export default {
  mixins: [onlyInputNumbers],
  components: {
    Label,
    AppInputDouble,
    InputSelect,
    TitleWithRow,
    Bioinsumos,
    Irrigacao,
    Financiamentos,
    EspecieEspacamento
  },

  props: {
    pratica: {
      type: Object,
      required: true
    },
    observer: {
      required: true
    }
  },
  data () {
    return {
      nomeAba: 'Práticas',
      especieFlorestal: null,
      espacamento: null,
      outraEspecieFlorestal: null,
      options
    }
  },

  computed: {
    disableButton () {
      const isOutros = this.especieFlorestal === 'OUTROS'
      return isOutros ? !this.outraEspecieFlorestal : !this.especieFlorestal
    }
  },

  methods: {
    containsOption (value, option, model) {
      let contains
      if (!Array.isArray(value)) {
        contains = value === option
      } else {
        contains = value.includes(option)
      }
      if (!contains) {
        const props = model.split('.')
        const lastProp = props.pop()
        const target = props.reduce((acc, curr) => acc?.[curr], this.pratica)
        if (target && lastProp) {
          target[lastProp] = null
        }
      }
      return contains
    },

    addEspecie () {
      this.pratica.especiesFlorestais.push({
        especie: this.especieFlorestal,
        espacamento: this.espacamento,
        especificacao: this.outraEspecieFlorestal
      })
      this.resetarCamposEspecie()
    },

    rmEspecie (prop) {
      const index = this.pratica.especiesFlorestais.findIndex((e) => e.especie === prop.especie)
      this.pratica.especiesFlorestais.splice(index, 1)
    },

    resetarCamposEspecie () {
      this.especieFlorestal = null
      this.outraEspecieFlorestal = null
      this.espacamento = null
    },

    nomeEspecie (prop) {
      return this.options.opcoesEspeciesFlorestais.find(o => prop.especie === o.id).nome
    }
  }
}
</script>

<template>
  <div>
    <el-row :gutter="20">
      <!-- item a -->
      <validation-provider rules="area" v-slot="{ errors }" :name="nomeAba + '/Área'">
        <el-col :span="6">
          <Label label="Área:" :obrigatorio="true" />
          <AppInputDouble
            :class="{ erro: errors.length, input: 'input' }"
            name='Área'
            :precision="2"
            :onkeypress="onlyInputNumbers"
            :showAppend ="true"
            v-model="pratica.area"
          />
          <span class="help erro">{{ errors[0] }}</span>
        </el-col>
      </validation-provider>
      <!-- item b -->
      <validation-provider rules="required" v-slot="{ errors }" :name="nomeAba + '/Data de início da implementação (mês/ano)'">
        <el-col :span="10">
          <Label label="Data de início da implementação (mês/ano):" :obrigatorio="true" />
            <el-date-picker
              v-model="pratica.dataInicio"
              type="month"
              placeholder="Selecione mês e ano"
              format="MM/yyyy"
              value-format="yyyy-MM-dd"
              style="width: 100%"
              :class="{'input erro' : errors.length}"
            />
          <span class="help erro">{{ errors[0] }}</span>
        </el-col>
      </validation-provider>
      <!-- item c -->
      <InputSelect
        label="Finalidade da floresta:"
        v-model="pratica.finalidades"
        :nomeAba="nomeAba"
        :obrigatorio="true"
        rulesInput="required"
        :opcoes="options.opcoesFinalidadeFloresta"
        :collapseTags="true"
        :collapseTagsTooltip="true"
        :widthColumn="8"
        multiSelect
      />
    </el-row>
    <el-row :gutter="20">
      <validation-provider
        v-if="containsOption(pratica.finalidades, 'OUTROS', 'outrasFinalidades')"
        rules="required"
        v-slot="{ errors }"
        mode="lazy"
        :name="`${nomeAba}/Outras Finalidades`"
      >
        <el-col :span="16">
          <Label
            label="Quais?"
            :obrigatorio="true"
          />
          <el-input
            name="Outras Finalidades"
            v-model="pratica.outrasFinalidades"
            :class="{'input erro' : errors.length}"
          />
          <span v-if="errors[0]" class="help erro"> {{ errors[0] }}</span>
        </el-col>
      </validation-provider>
    </el-row>
    <!-- item c III IV -->
    <TitleWithRow title="Espécies florestais e epaçamento" />
    <EspecieEspacamento
      :optionsSelect="options.opcoesEspeciesFlorestais"
      tituloCard="Espécie florestal"
      label1="Espécies florestais"
      nomeArraySalvar="especiesFlorestais"
      :pratica="pratica"
      :nomeAba="nomeAba"
      obrigatorio
    />

    <!-- item d -->
    <Bioinsumos
      :pratica="pratica"
      :nomeAba="nomeAba"
    />

    <!-- item e -->
    <Irrigacao
      :pratica="pratica"
      :nomeAba="nomeAba"
    />

    <!-- item f -->
    <Financiamentos
      :pratica="pratica"
      :nomeAba="nomeAba"
    />

    <!-- item g -->
    <TitleWithRow title="" />
    <el-row :gutter="20">
      <validation-provider
        v-slot="{ errors }"
        mode="lazy"
        :name="`${nomeAba}/Descrição`"
      >
      <el-col :span="24">
        <Label
          label="Descrição"
        />
        <el-input
          name="Descrição"
          v-model="pratica.descricao"
          :class="{'input erro' : errors.length}"
          type="textarea"
          maxlength="500"
          show-word-limit
        />
        <span v-if="errors[0]" class="help erro"> {{ errors[0] }}</span>
      </el-col>
      </validation-provider>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
@import './styles.scss';
</style>



// WEBPACK FOOTER //
// src/App/(authenticated)/modulos/cadastro/formulario-cadastro/praticas/form-praticas/FP/FP.vue